export default __webpack_public_path__ + "static/media/normal_icon.d749847d.pic";